
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#20253A","opacity":".4"}},[_c('path',{attrs:{"d":"M31.352 28.413a1.167 1.167 0 00-.604-1.117 16.428 16.428 0 01-8.201-10.962 1.166 1.166 0 00-1.288-.913 8.974 8.974 0 00-5.51 2.856 9.005 9.005 0 00-6.684-2.95C3.983 15.328 0 20.138 0 26.275A17.87 17.87 0 004.127 38.64a26.686 26.686 0 00-1.698 9.506c-.002 1.898.19 3.792.571 5.652A2.77 2.77 0 005.702 56a2.825 2.825 0 002.814-2.522c.6-5.49 3.708-9.63 7.233-9.63 3.526 0 6.634 4.14 7.234 9.632A2.825 2.825 0 0025.797 56a2.77 2.77 0 002.702-2.2c.382-1.86.574-3.753.572-5.651a26.685 26.685 0 00-1.7-9.506 16.907 16.907 0 003.982-10.23zM55.316 29.65a2.334 2.334 0 000-3.3l-5.465-5.464a1.167 1.167 0 01-.18-1.421 12.925 12.925 0 10-4.54 4.54 1.167 1.167 0 011.42.18l5.466 5.465a2.333 2.333 0 003.299 0zM30.333 12.903a8.237 8.237 0 1116.474 0 8.237 8.237 0 01-16.474 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h56v56H0z"}})])])])
          )
        }
      }
    